import { clientIdRedirect } from '#/src/shared/models';

export const checkClientId = (REDIRECT_ENABLED: boolean, clientId: string) =>
    REDIRECT_ENABLED && clientIdRedirect[clientId] ? clientIdRedirect[clientId] : clientId;
